// extracted by mini-css-extract-plugin
export default {"container":"ContentContainer__container--OhqydLeoasKjxhXcARqh"};